import { z } from 'zod'
import { appConfig } from '@/config/app.ts'
import { allySchema } from '@/modules/allies/allies/types/Ally.ts'

export type NewAllyData = z.infer<typeof allySchema>

export interface AllyState {
  isLoadingAllies: boolean
  isCreateAllyModalOpen: boolean
  isEditAllyModalOpen: boolean
  selectedAllyId: string | null
  walletId: string | null
  allyFilters: string
  newAllyData: NewAllyData | null
}

export const initialState: AllyState = {
  isLoadingAllies: false,
  isCreateAllyModalOpen: false,
  isEditAllyModalOpen: false,
  selectedAllyId: null,
  walletId: null,
  allyFilters: `?limit=${appConfig.pagination.defaultValue}`,
  newAllyData: null
}
